export default __webpack_public_path__ + "static/media/step_02.24d52b6d.png";